import { render, staticRenderFns } from "./CandidatesEntryTabFiles.vue?vue&type=template&id=83470108&scoped=true&"
import script from "./CandidatesEntryTabFiles.vue?vue&type=script&lang=js&"
export * from "./CandidatesEntryTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83470108",
  null
  
)

export default component.exports